import type { AxiosResponse } from 'axios'
import _defaultsDeep from 'lodash/defaultsDeep'
import snakeCase from 'snake-case'
import type { VNode } from 'vue'
import Vue from 'vue'
import type { Store } from 'vuex'
import Vuex from 'vuex'

// @ts-ignore
import Invoices from '../../_stores/collections/Invoices'
// @ts-ignore
import Payments from '../../_stores/collections/Payments'
// @ts-ignore
import PIFsV2 from '../../_stores/collections/PersonalInformationForms' // import PIFsV2 from './PIFsV2'; // @todo
// @ts-ignore
import ToDoItemsCollection from '../../_stores/collections/ToDoItems'
// @ts-ignore
import TravelAgents from '../../_stores/collections/TravelAgents'
// @ts-ignore
import StoreModel from '../../_stores/Store'
// @ts-ignore
import AppStatus from './AppStatus'
// @ts-ignore
import Attachments from './Attachments'
// @ts-ignore
import AttachmentsV2 from './AttachmentsV2'
// @ts-ignore
import Calendar from './client-dashboard/Calendar'
// @ts-ignore
import Dashboard from './client-dashboard/Dashboard'
// @ts-ignore
import FinalDocuments from './client-dashboard/FinalDocuments'
// @ts-ignore
import Notifications from './client-dashboard/Notifications'
// @ts-ignore
import PackingInformation from './client-dashboard/PackingInformation'
// @ts-ignore
import Payment from './client-dashboard/Payment'
// @ts-ignore
import PersonalInformationForms from './client-dashboard/PersonalInformationForms'
// @ts-ignore
import Reservation from './client-dashboard/Reservation'
// @ts-ignore
import ToDo from './client-dashboard/ToDo'
// @ts-ignore
import TravelInfo from './client-dashboard/TravelInfo'
// @ts-ignore
import FlightInfo from './client-dashboard/FlightInfo'
// @ts-ignore
import TripSpecialists from './client-dashboard/TripSpecialists'
// @ts-ignore
import UploadedDocuments from './client-dashboard/YourDocuments'
// @ts-ignore
import Countries from './Countries'
// @ts-ignore
import Events from './Events'
// @ts-ignore
import PackingInformationTemplates from './PackingInformationTemplates'
// @ts-ignore
import PaymentMethods from './PaymentMethods'
// @ts-ignore
import ResourceStoreTemplates from './ResourceStoreTemplates'
// @ts-ignore
import Settings from './Settings'
// @ts-ignore
import States from './States'
// @ts-ignore
import ToDoItems from './ToDoItems'
// @ts-ignore
import TodoTemplates from './ToDoTemplates'
// @ts-ignore
import TravelInfoTemplates from './TravelInfoTemplates'
// @ts-ignore
import TripDashboards from './TripDashboardsCollection'
// @ts-ignore
import Trips from './Trips'
import { UsersStoreModule as Users } from './Users'
// @ts-ignore
import WysiwygTemplates from './WysiwygTemplates'

// @ts-ignore // TODO: do not ignore
Vue.use(Vuex)

export interface TripDashboardStoreRootState {
  appIsReady: boolean
  finalDocumentsPopupOpen: boolean
  components: {
    Popup: VNode
  }
}

export const TripDashboardStore = new Vuex.Store(
  _defaultsDeep(StoreModel(), {
    modules: {
      Attachments,
      AttachmentsV2,
      Calendar,
      Dashboard,
      Events,
      FinalDocuments,
      Invoices,
      Notifications,
      Payment,
      PaymentMethods,
      Payments,
      PersonalInformationForms,
      PIFsV2,
      Reservation,
      ResourceStoreTemplates,
      ToDo,
      ToDoItems,
      TodoTemplates,
      FlightInfo,
      TravelInfo,
      TravelInfoTemplates,
      TravelAgents,
      PackingInformation,
      PackingInformationTemplates,
      Trips,
      TripSpecialists,
      TripDashboards,
      UploadedDocuments,
      Users,
      WysiwygTemplates,
      ToDoItemsCollection,
      Settings,
      AppStatus,
      Countries,
      States
    },
    state: {
      appIsReady: false,
      finalDocumentsPopupOpen: true,

      components: {
        Popup: null
      }
    },
    mutations: {
      appLoading(state: TripDashboardStoreRootState) {
        state.appIsReady = false
      },
      appReady(state: TripDashboardStoreRootState) {
        state.appIsReady = true
      },
      // @todo refactor usage of updateField into updateStore
      updateStore(state: TripDashboardStoreRootState, payload: any) {
        // TODO:
        // @ts-ignore // TODO:
        const newTripCollection = { ...state.Trips.collection }
        // @ts-ignore // TODO:
        newTripCollection[state.Trips.currentTripDashboardId][snakeCase(payload.store)] =
          payload.value
        // @ts-ignore // TODO:
        Vue.set(state.Trips, 'collection', newTripCollection)
      },
      updateField(
        state: TripDashboardStoreRootState,
        // TODO:
        payload: any
      ) {
        // @ts-ignore // TODO:
        const newTripCollection = { ...state.Trips.collection }
        if (payload.store !== 'Trip') {
          // @ts-ignore // TODO:
          newTripCollection[state.Trips.currentTripDashboardId][snakeCase(payload.store)][
            payload.field
          ] = payload.value
        } else {
          // @ts-ignore // TODO:
          newTripCollection[state.Trips.currentTripDashboardId].data[payload.field] = payload.value
        }
        // @ts-ignore // TODO:
        Vue.set(state.Trips, 'collection', newTripCollection)
      },
      // @todo refactor
      closeFinalDocumentsPopup(state: TripDashboardStoreRootState) {
        state.finalDocumentsPopupOpen = false
      },

      // set dynamic components
      setDynamicComponent(
        state: TripDashboardStoreRootState,
        payload: any // TODO:
      ) {
        if (payload.name) {
          // @ts-ignore // TODO:
          state.components[payload.name] = payload.component ?
            {
              component: payload.component,
              attributes: payload.attributes || {},
              handlers: payload.handlers || {}
            } :
            null
        }
      },
      updateNotifications(
        state: TripDashboardStoreRootState,
        // TODO:
        payload: any
      ) {
        const newTripCollection = {
          // @ts-ignore // TODO:
          ...state.Trips.collection
        }
        newTripCollection[
          // @ts-ignore // TODO:
          state.Trips.currentTripDashboardId
        ].notifications = payload
        // @ts-ignore // TODO:
        Vue.set(state.Trips, 'collection', newTripCollection)
      }
    },
    actions: {
      startup(ctx: Store<TripDashboardStoreRootState>) {
        // return Promise.all([ctx.dispatch(USER_ACTIONS.LOAD_CURRENT_USER)])
      },
      updateField(
        context: Store<TripDashboardStoreRootState>,
        // TODO:
        payload: any
      ) {
        context.dispatch('updateStatus', {
          key: 'saving',
          eventDate: new Date(),
          item: payload
        })
        const updateFieldEndpoint = context.getters.isOperator ? 'updateField' : 'updateClientField'
        // @ts-ignore // TODO:
        window.axios
          .post(
            // @ts-ignore // TODO:
            `${context.state.Trips.currentTripDashboardId}/${updateFieldEndpoint}`,
            payload
          )
          .then((response: AxiosResponse) => {
            if (response.status === 200) {
              context.commit('updateField', payload)
              context.commit('updateNotifications', response.data.notifications)
            }
            return context.dispatch('updateStatus', {
              key: 'last_saved',
              eventDate: new Date(),
              item: payload
            })
          })
          .catch(() => {
            return context.dispatch('updateStatus', {
              key: 'error',
              eventDate: new Date(),
              error: 'Something went wrong!',
              item: payload
            })
          })
      }
    }
  })
)
